import ContentMenu from './ContentMenu'
export { ContentMenu }
export default ContentMenu
